<template>
  <transition name="fade">
    <div v-if="active" class="countdown-overlay">
      <transition name="pop" mode="out-in">
        <div class="countdown-number" :key="count">{{ count }}</div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  active: Boolean,
  from: { type: Number, default: 3 }
})

const emit = defineEmits(['done'])
const count = ref(3)
let timer = null

watch(() => props.active, (val) => {
  if (val) {
    count.value = props.from
    timer = setInterval(() => {
      count.value--
      if (count.value <= 0) {
        clearInterval(timer)
        timer = null
        emit('done')
      }
    }, 1000)
  } else {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }
})
</script>

<style scoped>
.countdown-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: auto;
  display: flex;
  justify-content: center;
  padding-top: 16px;
  z-index: 10;
  pointer-events: none;
}

.countdown-number {
  font-size: 64px;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.6);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.pop-leave-active {
  transition: all 0.15s ease-in;
}
.pop-enter-from {
  opacity: 0;
  transform: scale(0.5);
}
.pop-leave-to {
  opacity: 0;
  transform: scale(1.5);
}
</style>
